export default __webpack_public_path__ + "static/media/learose-1024w.3f979b67.webp";